import React, { useEffect, useState } from "react";
import { Link, navigate, useStaticQuery, graphql } from "gatsby";
import { isMobile } from "../../../utils/helpers";
import { normalizeTwoWords } from "../../../shared/utils/stringUtilities";
import { ReferenciaCabecera } from "../../../interfaces/ReferenciaCabecera";
import leftArrow from "../../../assets/images/icons/flecha-izq.png";
import useBrowserMode from "../../../shared/hooks/useBrowserMode";
import useScrollDetect from "../../../shared/hooks/useScrollDetect";
import useDirectionScroll from "../../../shared/hooks/useDirectionScroll";
import ShareModal from "../../molecules/share-modal/shareModal";
import "../mentors-intern/mentorsIntern.scss"
import "./headboardOffer.scss"
import "../headboard-communities/headboardCommunities.scss"
import ToastAdvertiser from "../../atoms/toast-advertiser/toastAdvertiser";
import warningSvg from "../../../../src/assets/images/icons/warning-icon.svg";

interface HeadboardInfo {
    portafolio: string,
    tipo_formacion: string,
    region: {id: number, name:string, municipios: { id: number, name: string }},
    duracion: number,
    modalidad: string,
    foto_desktop?: string,
    video?: string,
};

const HeadboardOffer = (props: ReferenciaCabecera) => {
    const [ pageInfo, setPageInfo ] = useState<HeadboardInfo>({video: "", foto_desktop:"//images.ctfassets.net/203frbsx1z3n/u1JyIoEqw21tEo0AwDirt/5099f40075ab853699de9dfcda5ebd43/Banner_mobile_dark.jpg", portafolio:"", tipo_formacion:"", region:{id: 0, name: "", municipios: {id:0, name:""}}, duracion:0, modalidad:""});
    const [ showShareModal, setShowShareModal] = useState<boolean>(false);
    const { window, document } = useBrowserMode();
    const { isScrollActive, refElement } = useScrollDetect();
    const { lastDirection } = useDirectionScroll();
    const isTablet = () => window.matchMedia && window.matchMedia("(max-width: 1024px)").matches;

    const handleClick = () => {
        pageInfo.video && window.open(pageInfo.video, "_blank");
    }
    
    const icons = useStaticQuery(graphql`
        query MEDIAICONSCARD {
            iconTaller: allContentfulAsset(
                filter: { title: { eq: "iconTaller" } }
            ) {
                nodes {
                    file {
                        url
                    }
                }
            }
            iconMasterclass: allContentfulAsset(
                filter: { title: { eq: "iconMasterclass" } }
            ) {
                nodes {
                    file {
                        url
                    }
                }
            }
            iconCursos: allContentfulAsset(
                filter: { title: { eq: "iconCursos" } }
            ) {
                nodes {
                    file {
                        url
                    }
                }
            }
            iconLocation: allContentfulAsset(
                filter: {title: {eq: "iconLocation"}}
            ) {
                nodes {
                    file {
                        url
                    }
                }
            }
            iconDuration: allContentfulAsset(
                filter: {title: {eq: "iconDuration"}}
            ) {
                nodes {
                    file {
                        url
                    }
                }
            }
            iconModality: allContentfulAsset(
                filter: {title: {eq: "iconModality"}}
            ) {
                nodes {
                    file {
                        url
                    }
                }
            }
        }
    `);

    const iconTaller: string = icons.iconTaller.nodes[0].file.url || "";
    const iconMasterclass: string = icons.iconMasterclass.nodes[0].file.url || "";
    const iconCursos: string = icons.iconCursos.nodes[0].file.url || "";
    const iconDuration: string = icons.iconDuration.nodes[0].file.url || "";
    const iconLocation: string = icons.iconLocation.nodes[0].file.url || "";
    const iconModality: string = icons.iconModality.nodes[0].file.url || "";

    const switchIcons = (icon) => {
        switch (icon) {
            case "Taller":
                return iconTaller;
            case "Acompañamiento coach ":
                return iconMasterclass;
            case "Curso":
                return iconCursos;
            default:
                return iconMasterclass;
        }
    };

    const ulMenu: any = document.querySelector(
        ".o-headboard-communities__tabs.mobile"
    );
    const refTags = (props.referenciaTags || []).map((rt) => rt.localizador);

    const goToContent = (index: number) => {
            const element = document.getElementById(
                props.tipoCabecera + refTags[index][0]
            );
            element?.scrollIntoView({
                behavior: "smooth",
                block: "center"
            });
    };

    const moveUlMenu = (direction: string) => {
        const chevronLeft: any = document.querySelector(
            ".o-headboard-communities__arrow.icon-chevron-left"
        );
        const chevronRight: any = document.querySelector(
            ".o-headboard-communities__arrow.icon-chevron-right"
        );

        if (direction == "R") {
            ulMenu.scrollLeft += 200;
        } else {
            ulMenu.scrollLeft -= 200;
        }

        ulMenu.scrollLeft > 0
            ? chevronLeft.classList.add("active")
            : chevronLeft.classList.remove("active");
        ulMenu.scrollLeft > 400
            ? chevronRight.classList.remove("active")
            : chevronRight.classList.add("active");
    };

    useEffect (()=> {
        const courseInfo = localStorage.getItem("curso");
        courseInfo ? setPageInfo(JSON.parse(courseInfo)): navigate("/personas/aprendizaje/oferta");
    }, [])

    const videoUrlAuxiliar = pageInfo.video && pageInfo.video.split('/')[pageInfo.video.split('/').length - 1];

    return(
        <div ref={refElement}>
            <div className={`o-headboard-offer__container ${pageInfo.tipo_formacion && pageInfo.tipo_formacion === "MasterClass" && "o-headboard-offer__container--masterclass"}`}>
                <Link to= "/personas/aprendizaje/oferta" className="o-mentors-intern__back-button o-headboard-offer__back-button">
                    <img className="o-mentors-intern__arrow-link" alt="flecha izquierda" src={leftArrow}/>Regresar a ofertas
                </Link>
                <div className="o-headboard-offer__label-container">
                    <div className="o-headboard-offer__label">
                        <img
                            className="o-headboard-offer__label-img"
                            src={switchIcons(pageInfo.tipo_formacion)} 
                            alt="imagen ilustrativa curso"
                        />
                        <span className="o-headboard-offer__label-text">{pageInfo.tipo_formacion}</span>
                    </div>
                    {(pageInfo.tipo_formacion === 'Curso' ) ? (
                            <div className={`o-headboard-offer__label ${pageInfo.tipo_formacion === 'Curso' ?'o-headboard-offer__label--magenta' : ''}`}>
                                <span className="o-headboard-offer__label-text">Válido para Subsidio al desempleo</span>
                            </div>
                        ) : (
                            null
                        )}
                </div>
                <div className="o-headboard-offer__content-container">
                    <div className="o-headboard-offer__left-container">
                        <div className="o-headboard-offer__title-container">
                            <h2 className="o-headboard-offer__title">{pageInfo.portafolio}</h2>
                        </div>
                        {window.innerWidth < 768 && pageInfo.tipo_formacion && pageInfo.tipo_formacion === "MasterClass" ? 
                            <button className="o-headboard-offer__mobile-masterclass-preview" onClick={handleClick}>
                                <img 
                                    className="o-headboard-offer__desktop-img-masterclass"
                                    src={pageInfo.video && `https://img.youtube.com/vi/${videoUrlAuxiliar && videoUrlAuxiliar.includes("watch") ? videoUrlAuxiliar.split("=")[1]: videoUrlAuxiliar}/maxresdefault.jpg`}
                                    alt="imagen preview ilustrativa masterclass"
                                />
                            </button>
                        : null}
                        <div className="o-headboard-offer__options">
                            <div>
                                <div className="o-headboard-offer__img-container">
                                    <img src={iconLocation} alt="Icono ubicación"/>
                                </div>
                                <span className="o-headboard-offer__info-text">Region: {pageInfo.region?.name ? pageInfo.region?.name : "Todas"}</span>
                            </div>
                            <div>
                                <div className="o-headboard-offer__img-container">
                                    <img  src={iconDuration} alt="Icono duración"/>
                                </div>
                                <span className="o-headboard-offer__info-text">{pageInfo.duracion ? `Duración: ${pageInfo.duracion} Hora${pageInfo.duracion !== 1 && "s"}` : "Duración: Indefinido"}</span>
                            </div>
                            <div>
                                <div className="o-headboard-offer__img-container">
                                    <img src={iconModality} alt="Icono modalidad"/>
                                </div>
                                <span className="o-headboard-offer__info-text">Modalidad: {pageInfo?.modalidad ? pageInfo?.modalidad : "Virtual"}</span>
                            </div>
                        </div>
                        <button className="o-headboard-offer__button" onClick={() => window.open("../../formulario/talleres/", "_blank")}>
                            {pageInfo.tipo_formacion === "MasterClass" ? "VER MASTERCLASS" : "INSCRIBIRME YA"}
                        </button>
                    </div>
                    {window.innerWidth >= 768 ?
                        pageInfo.tipo_formacion && pageInfo.tipo_formacion === "MasterClass" ? 
                            <button className="o-headboard-offer__desktop-img" onClick={handleClick}>
                                <img 
                                    className="o-headboard-offer__desktop-img-masterclass"
                                    src={pageInfo.video && `https://img.youtube.com/vi/${videoUrlAuxiliar && videoUrlAuxiliar.includes("watch") ? videoUrlAuxiliar.split("=")[1]: videoUrlAuxiliar}/maxresdefault.jpg`}
                                    alt="imagen preview ilustrativa masterclass"
                                />
                            </button>
                        :
                            <img
                                className="o-headboard-offer__desktop-img" 
                                src={pageInfo.foto_desktop && pageInfo.foto_desktop.includes(" ^ ") ? pageInfo.foto_desktop.split(" ^ ")[0] : pageInfo.foto_desktop}
                                alt="imagen ilustrativa curso"
                            />
                    : null}
                </div>
                {pageInfo.tipo_formacion !== "MasterClass" && (
                    <ToastAdvertiser
                        imgSrc={warningSvg}
                        text="Para acceder a los cursos, debes estar actualmente sin empleo y haber realizado aportes los últimos 3 años a Caja de Compensación Familiar, acumulando un período total de cotización de 1 año como trabajador dependiente y de 2 años como independiente."
                        imgBgColor="#2B91FF"
                    />
                )}
            </div>
            {props.referenciaTags && pageInfo.tipo_formacion !== "MasterClass" && (
                <ul
                    className={`o-headboard-communities__tabs${
                        isScrollActive ? " tabs-fixed" : ""
                    }${lastDirection == -1 ? " tabs-fixed-move" : ""}${
                        (isMobile() || isTablet()) ? " mobile" : ""
                    }`}
                >
                    {(isMobile() || isTablet()) && (
                        <>
                            <span
                                className={`o-headboard-communities__arrow icon-chevron-left`}
                                onClick={() => moveUlMenu("L")}
                            ></span>
                            <span
                                className={`o-headboard-communities__arrow icon-chevron-right active`}
                                onClick={() => moveUlMenu("R")}
                            ></span>
                        </>
                    )}
                    {props.referenciaTags.map((value, index) => (
                        <li
                            key={`headerTab-${index}`}
                            className={`gtmConoceComfamaSuperior${normalizeTwoWords(
                                value.nombreTag
                            )} o-headboard-communities__tabs__tab`}
                            onClick={() => goToContent(index)}
                        >
                            {value.nombreTag}
                        </li>
                    ))}
                </ul>
            )}
            <ShareModal isOpen={showShareModal} onClose={() => {setShowShareModal(false)}} link={window.location.href} />
        </div>
    );
};

export default HeadboardOffer;